import React from 'react'
import * as Layout from 'views/layouts/MainLayout/MainLayout'
import { NoteType } from 'types/entities'
import { AddButton, FormComponents } from '@agro-club/frontend-shared'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'
import NoteList from '../../Note/NoteList/NoteList'
import NoteRoutes from 'views/pages/Note/routes'

type ContactNotesProps = {
  contact_id: string
  display_name: string
}

const ContactNotes: React.FC<ContactNotesProps> = ({ contact_id, display_name }) => {
  const { t } = useTranslation(['contact', 'common', 'validation'])

  return (
    <FormComponents.FormSection title={t('contact:form.contactNotes')}>
      <AddButton
        to={generatePath(NoteRoutes.Add, {
          note_type: NoteType.ContactNote,
          display_name: display_name,
          parent_id: contact_id,
        })}
      />
      <Layout.Content>
        <NoteList parent_id_filter={contact_id} note_type={NoteType.ContactNote} display_name={display_name} />
      </Layout.Content>
    </FormComponents.FormSection>
  )
}

export default ContactNotes
